import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useFamily } from '../context/FamilyContext';
import { subscribeToChores, subscribeToDailyCompletions, completeChore, uncompleteChore } from '@coparent/shared/src/services/choreService';
import ChoreList from '../components/chores/ChoreList';
import ChoreForm from '../components/chores/ChoreForm';
import { HiPlus, HiClock } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import NotificationBell from '../components/notifications/NotificationBell';

const ChoresPage = () => {
  const { currentUser } = useAuth();
  const { familyId } = useFamily();
  const [chores, setChores] = useState([]);
  const [completions, setCompletions] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingChore, setEditingChore] = useState(null);

  const todayStr = new Date().toISOString().split('T')[0];

  useEffect(() => {
    if (!familyId) return;
    const unsubs = [
      subscribeToChores(familyId, setChores),
      subscribeToDailyCompletions(familyId, todayStr, setCompletions),
    ];
    return () => unsubs.forEach(u => u());
  }, [familyId, todayStr]);

  const handleEdit = (chore) => {
    setEditingChore(chore);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingChore(null);
  };

  const handleToggleComplete = async (choreId, childId) => {
    const existing = completions.find(c => c.choreId === choreId && c.childId === childId);
    if (existing) {
      await uncompleteChore(familyId, choreId, existing.id);
    } else {
      await completeChore(familyId, choreId, {
        date: todayStr,
        childId,
        completedBy: currentUser.uid,
        household: currentUser.uid,
      });
    }
  };

  return (
    <div className="animate-fade-in">
      <div className="flex items-center justify-between page-header">
        <div>
          <h1 className="page-title">Chores</h1>
          <p className="page-subtitle">Track tasks across both households</p>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/chore-history"
            className="btn-secondary flex items-center gap-2 text-sm"
          >
            <HiClock className="text-base" />
            History
          </Link>
          <button
            onClick={() => { setEditingChore(null); setShowForm(true); }}
            className="btn-primary flex items-center gap-2 text-sm"
          >
            <HiPlus className="text-base" />
            Add Chore
          </button>
          <NotificationBell />
        </div>
      </div>

      <ChoreList
        chores={chores}
        completions={completions}
        onEdit={handleEdit}
        onToggleComplete={handleToggleComplete}
      />

      {showForm && (
        <ChoreForm
          key={editingChore?.id || 'new'}
          onClose={handleCloseForm}
          chore={editingChore}
        />
      )}
    </div>
  );
};

export default ChoresPage;
